import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-link-cell-renderer',
  template: `
    <a *ngIf="params?.data?.status == 'SUCCESS'" class="text-decoration-underline" (click)="onLinkClick($event, 'SUCCESS')">{{ 'View Record' }}</a>
    <a *ngIf="params?.data?.status == 'FAILED'" class="text-decoration-underline" (click)="onLinkClick($event, 'FAILED')">{{ 'Retry' }}</a>
    <a *ngIf="params?.data?.status == 'SKIPPED'" class="text-decoration-underline" (click)="onLinkClick($event, 'SKIPPED')">{{ 'Skipped' }}</a>
  `,
  styles: [`
    a { color: #1a73e8; cursor: pointer; text-decoration: underline; }
  `],
  standalone: false
})
export class LinkCellRendererComponent implements ICellRendererAngularComp {
  displayValue!: string;
  params!: any;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.displayValue = params.value;
    
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.displayValue = params.value;
    return true;
  }

  onLinkClick(event: Event, linkType: string): void {
    event.preventDefault();
    if (this.params.onClick instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: event,
        rowData: this.params.data,
        linkType: linkType
      };
      this.params.onClick(params);
    }
  }
}